"use client";

import { usePathname } from "next/navigation";

import { Sidebar } from "@/components/layout/sidebar";

export function AppShell({
    children,
    isDevelopmentEnvironment,
    coreVersion,
}: {
    children: React.ReactNode;
    isDevelopmentEnvironment: boolean;
    coreVersion: { version: string; buildId: string | null };
}) {
    const pathname = usePathname();
    const environmentMarker = isDevelopmentEnvironment ? (
        <div aria-label="개발 서버" className="fixed inset-x-0 top-0 z-[60] h-1 bg-amber-400" />
    ) : null;

    if (pathname === "/login" || pathname === "/demo") {
        return (
            <>
                {environmentMarker}
                <main className="min-h-screen min-w-0">{children}</main>
            </>
        );
    }

    return (
        <>
            {environmentMarker}
            <Sidebar isDevelopmentEnvironment={isDevelopmentEnvironment} coreVersion={coreVersion} />
            <main className="min-h-screen min-w-0 px-3 pb-6 pt-20 sm:px-5 lg:ml-64 lg:p-8">
                <div className="mx-auto min-w-0 max-w-7xl">{children}</div>
            </main>
        </>
    );
}
